/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./btnBack.vue?vue&type=template&id=e212e65c"
import script from "./btnBack.vue?vue&type=script&lang=js"
export * from "./btnBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports